import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["loading", "loadingMessage", "icon", "size", "block", "iconSize", "iconColor", "children", "skin", "btnType"];
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import ButtonBase from './ButtonBase';
import Container from './Label/Container';
import Label from './Label/Label';
import buttonPropTypes from '../prop-types/buttonPropTypes';
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var loading = _ref.loading,
      loadingMessage = _ref.loadingMessage,
      icon = _ref.icon,
      size = _ref.size,
      block = _ref.block,
      iconSize = _ref.iconSize,
      iconColor = _ref.iconColor,
      children = _ref.children,
      skin = _ref.skin,
      btnType = _ref.btnType,
      buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var intl = useIntl();

  if (loading) {
    return /*#__PURE__*/React.createElement(ButtonBase, Object.assign({
      ref: ref,
      sizeValue: size,
      blockValue: block,
      skin: skin,
      btnType: btnType
    }, buttonProps, {
      disabled: true
    }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Label, {
      skin: skin,
      size: iconSize,
      color: iconColor,
      btnSize: size,
      isLoading: loading,
      "aria-label": loadingMessage || intl.formatMessage({
        id: 'button.loadingMessage'
      })
    }, loadingMessage || intl.formatMessage({
      id: 'button.loadingMessage'
    }))));
  }

  var buttonContent = icon ? /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Label, {
    icon: icon,
    size: iconSize,
    color: iconColor,
    btnSize: size,
    skin: skin
  }, children)) : children;
  return /*#__PURE__*/React.createElement(ButtonBase, Object.assign({
    ref: ref,
    sizeValue: size,
    blockValue: block,
    skin: skin,
    btnType: btnType
  }, buttonProps), buttonContent);
});
Button.defaultProps = {
  skin: 'primary',
  btnType: 'default',
  size: 'default',
  disabled: null,
  loading: false,
  loadingMessage: null,
  icon: null,
  iconColor: 'currentColor',
  iconSize: null,
  block: false,
  children: null
};
export default Button;